// Loop Agent 相关接口（仅读；写路径走 MCP，不经此处）
import http from '@/plugins/wjtools'

// 列任务（按当前登录账号）
// 注意：wjtools 的 http.get(url, params) 第二个参数就是「查询参数对象」本身，
// 不要再包一层 { params }（否则 axios 收到的是 { params: {...} }，查询串变成
// params[status]=... 而非顶层 status/page/size，后端读不到 → 过滤/分页静默失效）。
export const fetchLoopTasks = (params) => http.get('loop-agent/tasks', params)

// 任务详情 + 事件流
// 同上：taskId 必须作为顶层查询参数下发，后端 @RequestParam("taskId") 是必填，
// 包成 { params: { taskId } } 会导致 taskId 缺失 → 20001 → 详情页状态/事件流空白。
export const fetchLoopTaskDetail = (taskId) => http.get('loop-agent/task-detail', { taskId })

// 任务运营统计（24h + 7d）
export const fetchLoopStats = () => http.get('loop-agent/stats')

// ============ Phase 3 Loop Skill 版本管理 ============
// 内置 bundle 文件清单(动态,供上传页展示期望文件)
export const fetchLoopSkillCatalog = () =>
  http.get('portal/loop-skill/catalog')

export const fetchLoopSkillCurrent = () =>
  http.get('portal/loop-skill/current')

export const fetchLoopSkillVersions = () =>
  http.get('portal/loop-skill/versions')

export const fetchLoopSkillVersionFiles = (bundleVersionId) =>
  http.get(`portal/loop-skill/versions/${bundleVersionId}/files`)

export const fetchLoopSkillDraft = () =>
  http.get('portal/loop-skill/draft')

export const initLoopSkillDraft = () =>
  http.post('portal/loop-skill/draft/init')

export const saveLoopSkillDraft = (payload) =>
  http.put('portal/loop-skill/draft', payload)

export const publishLoopSkillDraft = (payload) =>
  http.post('portal/loop-skill/draft/publish', payload)

export const deleteLoopSkillDraft = () =>
  http.del('portal/loop-skill/draft')

export const uploadLoopSkillBundle = (formData) =>
  http.post('portal/loop-skill/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })

export const switchLoopSkillActive = (bundleVersionId) =>
  http.put('portal/loop-skill/active', { bundleVersionId })

export const deleteLoopSkillVersion = (bundleVersionId) =>
  http.del(`portal/loop-skill/versions/${bundleVersionId}`)

// 打包下载当前生效 bundle / 指定历史版本（zip）。notHandle:true 拿到完整 axios 响应,
// 便于从 Content-Disposition 解析文件名;responseType:'blob' 拿到二进制。
export const downloadLoopSkillCurrent = () =>
  http.get('portal/loop-skill/download/current', {}, { responseType: 'blob', notHandle: true })

export const downloadLoopSkillVersion = (versionId) =>
  http.get(`portal/loop-skill/versions/${versionId}/download`, {}, { responseType: 'blob', notHandle: true })

// 下载 Wechatsync 浏览器扩展 zip（公开端点，无需 ApiKey；给 /distribute-goal 本地发布用）
export const downloadWechatsyncExtension = () =>
  http.get('wechatsync/extension.zip', {}, { responseType: 'blob', notHandle: true })

// Wechatsync 扩展/mcp-server 版本（skill管理页展示，避免前端写死）
export const getWechatsyncVersion = () =>
  http.get('wechatsync/version')

// ============ 全局 skill bundle（管理员）============
export const uploadGlobalSkillBundle = (formData) =>
  http.post('portal/loop-skill/upload-global', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })

export const fetchGlobalSkillVersions = () =>
  http.get('portal/loop-skill/global-versions')

export const deleteGlobalSkillVersion = (bundleVersionId) =>
  http.del(`portal/loop-skill/global-versions/${bundleVersionId}`)

// 查询全局默认开关（管理员；非管理员后端返 200 + R{success:false}，前端按 success 字段探测管理员身份）
export const getGlobalDefaultEnabled = () =>
  http.get('portal/loop-skill/global-default-enabled')

// 设置全局默认开关
export const setGlobalDefaultEnabled = (enabled) =>
  http.put('portal/loop-skill/global-default-enabled', { enabled })

// 用官方内置覆盖全局默认（把 classpath built-in 写成新 global 行）
export const promoteBuiltin = () =>
  http.post('portal/loop-skill/promote-builtin')
